import React, { useEffect, useRef, useState } from 'react';

const getDisplayName = (p) => p?.name ?? p?.displayName ?? p?.label ?? 'Date';

const TimelinePanel = ({ title, params, onPick }) => {
  const panelRef = useRef(null);
  const [pos, setPos] = useState(null);

  useEffect(() => {
    const update = () => {
      const panelEl = panelRef.current;
      if (!panelEl) return;

      const anchorEl =
        document.getElementById('adsk-toolbar-extension-timevar-button') ||
        document.querySelector('.adsk-toolbar-extension-timevar-button');
      if (!anchorEl) return;

      const rect = anchorEl.getBoundingClientRect();
      const { innerWidth: vw, innerHeight: vh } = window;
      const margin = 8;

      // Ensure panel has layout before measuring.
      const panelRect = panelEl.getBoundingClientRect();
      const pw = panelRect.width || 260;
      const ph = panelRect.height || 200;

      // Prefer aligning right edges under the button.
      let left = rect.right - pw;
      left = Math.max(margin, Math.min(left, vw - pw - margin));

      // Prefer opening below the button; if doesn't fit, open above.
      let top = rect.bottom + margin;
      if (top + ph > vh - margin) {
        top = rect.top - ph - margin;
      }
      top = Math.max(margin, Math.min(top, vh - ph - margin));

      setPos({ left, top });
    };

    update();
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, true);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update, true);
    };
  }, [params?.length]);

  return (
    <div
      ref={panelRef}
      className="timeline-panel"
      style={pos ? { left: pos.left, top: pos.top } : undefined}
    >
      <div className="timeline-panel__title">{title || 'Timeline'}</div>
      <ul className="timeline-panel__list">
        {params?.map((param) => {
          const id = param.id ?? param.guid ?? param.name;
          return (
            <li key={id} className="timeline-panel__item">
              <button type="button" className="timeline-panel__btn" onClick={() => onPick(param)} title={getDisplayName(param)}>
                <span className="timeline-panel__dot" />
                <span className="timeline-panel__text">{getDisplayName(param)}</span>
              </button>
            </li>
          );
        })}
        {!params?.length && <li className="timeline-panel__empty">No date parameters</li>}
      </ul>
    </div>
  );
};

export default TimelinePanel;